// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import App from './App';
import { GoogleOAuthProvider } from "@react-oauth/google";

const clientId = "1071122169939-t88jj83ds7mic3j077l0ntnb139rk9l9.apps.googleusercontent.com";
ReactDOM.render(
 
  <Provider store={store}>
      <GoogleOAuthProvider clientId={clientId}>
    <App />
    </GoogleOAuthProvider>
  </Provider>,
  document.getElementById('root')
);
